import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';

const cfg = {
  isAsEnabled: false,
  policyType: 42,
  tmVirusscans: {
    vsAdditionalThreatsActionType: 249,
    vsMaliciousActionType: 249,
    vsMassingMailingActionType: 6,
    vsPackersActionType: 249,
    vsRansomwareActionType: 249,
    vsTextTagSubjectContent: 'Suspicious File:',
    vsUncleanableThreatsActionType: 6,
    vsVirusesActionType: 249,
    vsWormsTrojansActionType: 249,
  },

  tmFileblockings: {
    fbActionType: 249,
  },

  tmWebthreatprotections: {
    wtpActionBlockedUrl: 249,
    wtpActionType: 249,
    wtpApprovedHeaderList: '',
  },

  tmDdafilters: {
    ddaActionHighRisk: 249,
    ddaActionMediumRisk: 249,
  },
};

export function getTeamsChatTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.MTC.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.MTC.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.MTC.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.MTC.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.MTC.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.MTC.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.MTC.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.MTC.tmDdafilters.notification.ntfAdminSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  return getTemplateConfig(t, tempConfig, accountEmail, [], ntfI18nReplaceKeys);
}
